import { RegisterContext } from "../../../../utilities/register/context";

export interface RegisterProviderProps {
  cartRevealAtWidth: number;
  children?: React.ReactNode;
}

export function RegisterProvider({
  cartRevealAtWidth,
  children,
}: RegisterProviderProps) {
  return (
    <RegisterContext.Provider value={{ cartRevealAtWidth }}>
      {children}
    </RegisterContext.Provider>
  );
}
